import { SVGProps } from 'react';

export const MoveToSectionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 156 131" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M149 7L58.5 7" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path d="M148.5 85L81.5 85" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path d="M148.5 46L81.5 46" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path d="M149 124H58.5" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path
        d="M64.9273 73.3134C70.0039 70.1896 70.0039 62.8104 64.9273 59.6866L31.1925 38.9284C25.8624 35.6486 19 39.4834 19 45.7419V87.2581C19 93.5166 25.8624 97.3514 31.1925 94.0716L64.9273 73.3134Z"
        fill="currentColor"
      />
    </svg>
  );
};
